import script from "./MileageCorrectionTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MileageCorrectionTable.vue?vue&type=script&setup=true&lang=ts"

import "./MileageCorrectionTable.vue?vue&type=style&index=0&id=546db328&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-546db328"]])

export default __exports__